import { render, staticRenderFns } from "./UserNotificationForm.vue?vue&type=template&id=44b27cea&"
import script from "./UserNotificationForm.vue?vue&type=script&lang=ts&"
export * from "./UserNotificationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports